import development from './development';

/**
 * Override here which ever required
 * development.SSR_GQL_ENDPOINT = ""
 */
export default { ...development };
